module.exports = __webpack_public_path__ + "img/bubble_layout_1.20f0f6a1.svg";